// extracted by mini-css-extract-plugin
export default {"button-selector":"ButtonSelector_button-selector__yRk+4","selected":"ButtonSelector_selected__LoQ66"};